import { AliasToken } from 'antd/es/theme/internal';
import { responsiveStyle } from '../../util/helpers';
import { windowBreakpoints } from '../../hooks/useDeviceSize';

export const sidebarStyle = (globalStyle: AliasToken, viewportSize: windowBreakpoints, isActive?: boolean) =>
  responsiveStyle(viewportSize, {
    sidebar: {
      backgroundColor: globalStyle.colorPrimary,
      transition: `transform ease-in-out ${globalStyle.motionDurationMid}`,
      height: '100%',
      margin: 0,
      width: '100%',
      '!desktop': {
        position: 'fixed',
        zIndex: 1,
        width: '50%',
        transform: `translateX(${isActive ? '0' : '-100%'})`,
      },
    },
    sidebarMenu: {
      height: '100%',
      '!desktop': {
        zIndex: 9999,
      },
    },
    sidebarText: {
      color: globalStyle.colorTextSecondary,
      fontWeight: 600,
    },
    sidebarTextAlt: {
      color: globalStyle.colorTextSecondary,
      fontWeight: 50,
    },
    sidebarHeader: {
      paddingLeft: '26px',
      height: '10%',
    },
    sidebarHeaderText: {
      color: globalStyle.colorTextSecondary,
    },
    sidebarAvatar: {
      width: '56px',
      height: '56px',
      aspectRatio: '1/1',
      borderRadius: '12px',
    },
  });

export default sidebarStyle;
